import React from 'react';

import { AttributeDesktop } from './impl/AttributeDesktop/AttributeDesktop';

export class ExplanationAttributesDesktop extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      attributes: this.props.attributes
    }
    this.toggleDescription = this.toggleDescription.bind(this);
  }

  // 2do: useCallback
  toggleDescription(attr) {
    const newAttr = this.state.attributes.map(_ => {
      if (_.short_name === attr.short_name && _.type === attr.type) {
        _.isActive = !attr.isActive
      } else {
        _.isActive = false
      }

      return _;
    })

    this.setState(prevState => {
      return { attributes: newAttr }
    });

    const cb = this.props.callbackUpdatedAttributes
    cb && cb({ attributes: this.state.attributes })
  }

  render() {
    return (
      <React.Fragment>
        {this.props.attributes.map((attr, idx) =>
          <AttributeDesktop
            key={idx} attr={attr}
            toggleDescription={() => this.toggleDescription(attr)}
          />
        )}
      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/snippets/ExplanationAttributes/ExplanationAttributesDesktop.jsx